import React from 'react';

const BsCol = (props) => (
  <div className={props.class} style={props.style}>
    {props.children}
  </div>
);

export default BsCol;
